import { render, staticRenderFns } from "./companyServe.vue?vue&type=template&id=7c5d8b47&scoped=true"
import script from "./companyServe.vue?vue&type=script&lang=ts"
export * from "./companyServe.vue?vue&type=script&lang=ts"
import style0 from "./companyServe.vue?vue&type=style&index=0&id=7c5d8b47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d8b47",
  null
  
)

export default component.exports